import { Component, OnDestroy, OnInit, Optional, Self } from '@angular/core';
import { FormBuilder, NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AssistantPopoverService } from '../../../common/assistant-popover.service';
import { ValidationService } from '../../../common/validation.service';
import { leapDayValidator } from '../../../common/validators';
import { ValueListsService } from '../../../common/value-lists.service';
import { ValueListItem } from '../../../models/rest/valuelist/valuelist';
import { VisumErfassungSubFormComponent } from '../visum-erfassung-sub-form/visum-erfassung-sub-form.component';

@Component({
  selector: 'app-einreisegenehmigung',
  templateUrl: './einreisegenehmigung.component.html',
  styleUrls: ['./einreisegenehmigung.component.scss']
})
export class EinreisegenehmigungComponent extends VisumErfassungSubFormComponent implements OnInit, OnDestroy {
  private landListItemsSub: Subscription;
  landListItems: ValueListItem[];

  constructor(fb: FormBuilder,
              private valueListsService: ValueListsService,
              private validationService: ValidationService,
              assistentPopoverService: AssistantPopoverService,
              @Optional() @Self() controlDir: NgControl) {
    super(controlDir, assistentPopoverService);

    this.form = this.wrapFormGroup(fb.group({
      endzielStaat: [null, validationService.getValidators('antragsteller.einreisegenehmigung.endzielStaat')],
      gueltigVon: [null, [...validationService.getValidators('antragsteller.einreisegenehmigung.gueltigVon'), leapDayValidator]],
      gueltigBis: [null, [...validationService.getValidators('antragsteller.einreisegenehmigung.gueltigBis'), leapDayValidator]],
      ausgestelltVon: [null, validationService.getValidators('antragsteller.einreisegenehmigung.ausgestelltVon')]
    }));
  }

  ngOnInit() {
    super.ngOnInit();

    this.landListItemsSub = this.valueListsService.getValueListItems('land')
        .subscribe((listItems: ValueListItem[]) => this.landListItems = listItems);
  }

  ngOnDestroy(): void {
    this.landListItemsSub.unsubscribe();
  }

  onValidatorUpdate() {
    super.onValidatorUpdate();
  }
}
